import { LocalStorage } from "../utils/browser";

const creatorTosModalStoreKey = "sc-tos-modal";

export interface TosMap {
    hideTos: boolean;
}

const defaultTosModalStoreMap: TosMap = {
    hideTos: false,
};

export class TosModalStore extends LocalStorage {
    constructor(public override key: string) {
        super(key);

        const store = this.getItem<TosMap>();
        if (!store) {
            super.setItem(defaultTosModalStoreMap);
        }
    }
}

export const creatorTosModalStore = new TosModalStore(creatorTosModalStoreKey);
